import { LayerManager } from './layerManager';

let instance: LayerManager | null = null;

/** ponytail: one LayerManager for the session */
export function getLayerManager(): LayerManager {
  if (!instance) instance = new LayerManager();
  return instance;
}